import React from "react";

import { useTranslation } from 'react-i18next';
const BADGE_CONFIGS = {
  verified: { label: "Verificado", bg: "bg-green-500/20", text: "text-green-400", border: "border-green-500/30" },
  pending: { label: "Pendente", bg: "bg-yellow-500/20", text: "text-yellow-400", border: "border-yellow-500/30" },
  rejected: { label: "Rejeitado", bg: "bg-red-500/20", text: "text-red-400", border: "border-red-500/30" },
  premium: { label: "Premium", bg: "bg-purple-500/20", text: "text-purple-400", border: "border-purple-500/30" },
  top_creator: { label: "Top Creator", bg: "bg-amber-500/20", text: "text-amber-400", border: "border-amber-500/30" },
};

/**
 * VerificationBadge — shows creator verification status
 * @param {string} status - "verified" | "pending" | "rejected" | "premium" | "top_creator"
 * @param {boolean} verified - shorthand for status="verified" (backward compat)
 * @param {string} size - "sm" | "md" | "lg"
 */
export default function VerificationBadge({ status, verified, size = "sm" }) {
  const { t } = useTranslation();
  // Backward compat: if verified=true and no status, use "verified"
  const resolvedStatus = status || (verified ? "verified" : "pending");
  const config = BADGE_CONFIGS[resolvedStatus] || BADGE_CONFIGS.verified;
  const sizeClasses =
    size === "lg" ? "px-3 py-1 text-sm" : size === "md" ? "px-2.5 py-0.5 text-xs" : "px-2 py-0.5 text-[10px]";

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium border rounded-sm ${config.bg} ${config.text} ${config.border} ${sizeClasses}`}
    >
      {resolvedStatus === "verified" && (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      )}
      {resolvedStatus === "premium" && <span className="text-[10px]">★</span>}
      {resolvedStatus === "top_creator" && <span className="text-[10px]">🏆</span>}
      {config.label}
    </span>
  );
}

export const StatusIndicator = ({ status }) => {
  const dotColors = { verified: "bg-green-500", pending: "bg-yellow-500", rejected: "bg-red-500" };
  return (
    <div className="flex items-center gap-1.5">
      <span className={`w-2 h-2 rounded-full ${dotColors[status] || dotColors.pending}`} />
      <span className="text-[10px] font-mono uppercase tracking-wider text-zinc-400">
        {status === "verified" ? "Verificado" : status === "rejected" ? "Rejeitado" : "Pendente"}
      </span>
    </div>
  );
};
